module.exports = __webpack_public_path__ + "static/IcoMoon-Free-a453b344567040b8c2473bb32d7e0bc3.ttf";